export const environment = {
    production: false,
    baseUrl: 'https://assinar.test.api.dentaloffice.com.br',
    frontUrl: 'https://assinar.test.dentaloffice.com.br/',
    amplitudeApiKey: 'e7fdde7b75bc72f31170499d0fefeb93'
};
